import axios from "axios";

export const sendEmail = async (invoiceData, userDetails) => {
  const apiKey = "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"; // Your Brevo API key
  const endpoint = "https://api.brevo.com/v3/smtp/email";

  // Ensure invoiceData.items is defined and is an array
  const items = Array.isArray(invoiceData.items) ? invoiceData.items : [];

  const emailData = {
    sender: { name: "Motor Easy", email: "muhammadfayyaz0097@gmail.com" }, // Replace with a verified email
    to: [{ email: userDetails.email, name: userDetails.name }],
    subject: "Your Motor Easy Invoice",
    htmlContent: `
      <html>
        <head>
          <style>
            /* Additional CSS styles here, if needed */
          </style>
          <!-- Bootstrap CDN (adjust version if needed) -->
          <link href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" rel="stylesheet">
        </head>
        <body>
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-8">
                <div class="card">
                  <div class="card-header bg-primary text-white">
                    <h2 class="mb-0">Motor Easy Invoice</h2>
                  </div>
                  <div class="card-body">
                    <div class="row mb-4">
                      <div class="col-sm-6">
                        <h5>Invoice Number:</h5>
                        <p>#${invoiceData.invoiceNumber || "123456"}</p>
                        <h5>Invoice Date:</h5>
                        <p>${invoiceData.date || "April 05, 2020"}</p>
                      </div>
                      <div class="col-sm-6">
                        <h5>Customer Details:</h5>
                        <p><strong>Name:</strong> ${userDetails.name}</p>
                        <p><strong>Email:</strong> ${userDetails.email}</p>
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table table-bordered">
                        <thead class="bg-light">
                          <tr>
                            <th scope="col">No.</th>
                            <th scope="col">Product Description</th>
                            <th scope="col">Price</th>
                            <th scope="col">Quantity</th>
                            <th scope="col">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          ${items
        .map(
          (item, index) => `
                                <tr>
                                  <td>${index + 1}</td>
                                  <td>${item.description}</td>
                                  <td>$${item.price}</td>
                                  <td>${item.quantity}</td>
                                  <td>$${item.price * item.quantity}</td>
                                </tr>
                              `
        )
        .join("")}
                        </tbody>
                      </table>
                    </div>
                    <div class="row justify-content-end">
                      <div class="col-sm-4">
                        <div class="card">
                          <div class="card-body">
                            <h5 class="card-title">Invoice Summary</h5>
                            <p><strong>Subtotal:</strong> $${invoiceData.subtotal || "1000.00"}</p>
                            <p><strong>Tax (10%):</strong> $${invoiceData.tax || "100.00"}</p>
                            <p><strong>Total:</strong> $${invoiceData.total || "1100.00"}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="text-center mt-4">
                      <p>Thank you for your business!</p>
                      <p><strong>Your Name & Signature</strong><br>Account Manager</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </body>
      </html>
    `,
    attachment: [
      {
        content: invoiceData.pdfBase64,
        name: "invoice.pdf",
        type: "application/pdf",
      },
    ],
  };

  try {
    await axios.post(endpoint, emailData, {
      headers: {
        "api-key": apiKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
    });
    console.log("Email sent successfully.");
  } catch (error) {
    console.error("Error sending email:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
    }
  }
};
